import React from 'react';

import {RemoveIcon} from 'src/components/remove-icon';

import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';


import {
    selectedManager,
    selectedManagerEmail,
    selectedManagerName,
} from './selected-manager.module.styl';

import type {AccountManagerSearchResult} from 'src/openapi/admin/models/AccountManagerSearchResult';

type Props = {
    selectedTeamMember: AccountManagerSearchResult,
    onSelectedClear: () => void,
};

export const SelectedTeamMember = ({selectedTeamMember: {id, avatar, fullName, email}, onSelectedClear}: Props) => (
    <Group justify="start" alignItems="center" className={selectedManager}>
        <AvatarWrapped
            src={avatar}
            alt={id.toString()}
            placeholder={Icons.USER}
            size={Size.SMALL}
            name={fullName}
        />
        <div className={selectedManagerName}>
            <EllipsisTextHint title={fullName} bold={true}>{fullName}</EllipsisTextHint>
        </div>
        <div className={`disabled ${selectedManagerEmail}`}>
            <EllipsisTextHint title={email}>{email}</EllipsisTextHint>
        </div>
        <RemoveIcon handler={onSelectedClear}/>
    </Group>
);
